import { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import { fetchCategoryTree, flattenCategoryTree } from '../services/categoryService';

/**
 * Hook to load and manage the category tree for the authenticated tenant
 */
export const useCategoryTree = () => {
  const { state, dispatch } = useApp();
  const { isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated && !state.categoryTree) {
      loadCategoryTree();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const loadCategoryTree = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const tree = await fetchCategoryTree();
      const flattened = flattenCategoryTree(tree);

      dispatch({
        type: 'SET_CATEGORY_TREE',
        payload: { tree, flattened }
      });
    } catch (err) {
      console.error('Failed to load category tree:', err);
      setError(err instanceof Error ? err.message : 'Failed to load category tree');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    categoryTree: state.categoryTree,
    flatCategories: state.flatCategories,
    isLoading,
    error,
    reload: loadCategoryTree
  };
};